module.exports = __webpack_public_path__ + "static/media/docusign.cc43ca91.svg";